import { h } from "vue"
import { NAlert } from "naive-ui"

export const global = {
	//locale
	//notification
	//message
}

export function makeKebab(camelOrPascalText) {
	return camelOrPascalText.replace(/(?!^)([A-Z])/g, "-$1").toLowerCase()
}

export function makeCamel(kebabText) {
	return kebabText.replace(/-\w/g, (x) => x[1].toUpperCase())
}

export function makePascal(kebabText) {
	return kebabText.replace(/(?:^|-)\w/g, (x) => x[x.length - 1].toUpperCase())
}

export function getBuildNumber(timestamp) {
	return (
		"b" +
		new Date(timestamp).toISOString().split("T")[0].replaceAll("-", ".")
	)
}

export function extractBuildNumber(rootElement) {
	const buildTimestamp = Number(rootElement.dataset.buildTimestampUtc)
	rootElement.removeAttribute("data-build-timestamp-utc")

	return getBuildNumber(buildTimestamp)
}

export function renderAlertMessage(props) {
	const { type, content, closable, onClose } = props
	const [head, body] = content.split("::")

	return h(
		NAlert,
		{
			closable: closable,
			onClose: onClose,
			type: type === "loading" ? "default" : type,
			title: head,
			style: {
				boxShadow: "var(--n-box-shadow)",
				maxWidth: "calc(100vw - 32px)",
			},
		},
		body === undefined
			? {}
			: {
					default: () => body,
			  }
	)
}

export function parseJwt(token) {
	try {
		return JSON.parse(atob(token.split(".")[1]))
	} catch (e) {
		return null
	}
}
